module.exports = __webpack_public_path__ + "static/media/subscription2.067eb87d.png";